import { HeroConversationMessage } from '@vs-online-only-app/state';
import { FC } from 'react';
import ChatBubble from './ChatBubble';
import styled from 'styled-components';
import {
  UserAvatar,
  MediaCard,
  PreviewSize,
  MediaType,
} from '@vs-online-only-app/ui';
import { format } from 'date-fns';
import useConversationMessage from '../../hooks/useConversationMessage';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';

type Props = {
  message: HeroConversationMessage;
};

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ theme }) => theme.spacing(4)} 1fr;
  column-gap: ${({ theme }) => theme.spacing(1)};
`;

const MediaMessage: FC<Props> = ({ message }) => {
  const heroConversation = useSelectedHeroConversation();
  const conversationStarter = heroConversation?.conversationStarter;

  const { variant, isFirstInStack, isStacked, isLastInStack, mediaUrl } =
    useConversationMessage(message);

  const isArchived = heroConversation?.archiveAttributes;

  return (
    <GridWrapper>
      {variant === 'incoming' && (isFirstInStack || !isStacked) && (
        <UserAvatar
          color={isArchived ? undefined : '#E95D11'} // Bambuser orange
          fallbackCharacter={conversationStarter?.firstName.charAt(0)}
        />
      )}
      <div
        style={{
          gridColumn: variant === 'incoming' ? '2/3' : '1/3',
        }}
      >
        <ChatBubble
          noPadding
          maxWidthPercentage={50}
          minWidthPercentage={50}
          direction={variant === 'incoming' ? 'left' : 'right'}
          isLastInStack={isLastInStack}
          isFirstInStack={isFirstInStack}
          isStacked={isStacked}
          backgroundColor={variant === 'outgoing' ? 'primary' : 'secondary'}
          borderColor={variant === 'outgoing' ? 'primary' : 'secondary'}
        >
          {mediaUrl && (
            <MediaCard
              size={PreviewSize.Large}
              url={mediaUrl}
              mediaType={
                message.attributes.type === 'photo'
                  ? MediaType.Image
                  : MediaType.Video
              }
              timestamp={
                message?.dateCreated ? format(message.dateCreated, 'HH:mm') : ''
              }
              sending={message.index === undefined}
              showCenterIcon
            />
          )}
        </ChatBubble>
      </div>
    </GridWrapper>
  );
};

export default MediaMessage;
